import { ObjectHelpers } from "../../helpers/object-helpers";

export class MarketingAISignalModel {
    public entryDescription = '';
    public entryDate = '';
    public entryTime = '';
    public entryPrice = 0;
    public exitDescription = '';
    public exitDate = '';
    public exitTime = '';
    public exitPercentage = 0;

    constructor(data?: any) {
        if (data) {
            ObjectHelpers.setProperties(data, this, true);
        }
    }
}
